import React from "react";
import { Award } from "lucide-react";
import { parseCertifications } from "../lib/certifications";

/**
 * Catalog teacher certifications (Award cards).
 * @param {{ certifications?: string, className?: string, compact?: boolean }} props
 */
export default function CertificationsSection({ certifications, className = "", compact = false }) {
  const certs = parseCertifications(certifications);
  if (certs.length === 0) return null;

  const shell = compact
    ? "bg-white rounded-2xl p-6 shadow-sm border border-gray-100"
    : "bg-white rounded-3xl p-8 shadow-sm border border-gray-100";
  const heading = compact
    ? "text-lg font-bold text-gray-900 mb-4 flex items-center gap-2"
    : "text-xl font-black text-gray-900 mb-5 flex items-center gap-2";

  return (
    <section className={`${shell} ${className}`.trim()}>
      <h2 className={heading}>
        <Award size={18} className="text-emerald-500" /> Certifications
      </h2>
      <ul className="grid gap-3 sm:grid-cols-2">
        {certs.map((cert) => (
          <li
            key={cert.key}
            className="relative overflow-hidden rounded-2xl border border-emerald-100 bg-gradient-to-br from-emerald-50/80 via-white to-teal-50/40 px-4 py-4"
          >
            <div className="absolute -right-3 -top-3 h-16 w-16 rounded-full bg-emerald-100/50" />
            <div className="relative flex gap-3">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-emerald-600 text-white shadow-sm">
                <Award size={18} />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-start justify-between gap-2">
                  <p className="font-bold text-gray-900 leading-snug">{cert.name}</p>
                  {cert.year ? (
                    <span className="shrink-0 rounded-full bg-emerald-600/10 px-2 py-0.5 text-[11px] font-bold tracking-wide text-emerald-800">
                      {cert.year}
                    </span>
                  ) : null}
                </div>
                {cert.issuer ? (
                  <p className="mt-1 text-sm text-gray-600 leading-snug">{cert.issuer}</p>
                ) : null}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
